<template>
  <div class="custom-checklist">
    <div class="custom-checklist-counter">
      {{ checkedItemsCount }}/{{ checklistItems.length }}
    </div>

    <div class="custom-checklist__container">
      <div
        v-for="(item, index) in localChecklistItems"
        :key="index"
        class="custom-checklist-item">
        <input
          :id="`${componentId}-${index}`"
          :checked="item.checked"
          type="checkbox"
          class="custom-checklist__input"
          @input="toggleChecked(index)">

        <label
          :for="`${componentId}-${index}`"
          class="custom-checklist__text"
          @click.prevent="toggleChecked(index)">{{ item.text }}</label>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    checklistItems: {
      type: Array,
      required: true,
    },
  },

  data() {
    return {
      localChecklistItems: JSON.parse(JSON.stringify(this.checklistItems)),
      componentId: this.generateUniqueId(),
    };
  },

  computed: {
    checkedItemsCount() {
      return this.localChecklistItems.filter((item) => item.checked).length;
    },
  },

  methods: {
    generateUniqueId() {
      return Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15);
    },

    toggleChecked(index) {
      this.localChecklistItems[index].checked = !this.localChecklistItems[index].checked;
    },
  },
};
</script>

<style lang="scss" scoped>
.custom-checklist {
  margin: 40px 0;
}

.custom-checklist__container {
  display: grid;
  grid-row-gap: 35px;
}

.custom-checklist__input {
  display: none;
}

.custom-checklist__input:checked + label {
  text-decoration: line-through;
}

.custom-checklist__input:checked + label::before {
  background-size: 40px 40px;
  content: '';
  display: inline-block;
  width: 40px;
  height: 40px;
  position: absolute;
  left: 0;
  top: 50%;
  transform: translateY(-50%);
  background: transparent url(/images/icons/check.svg) no-repeat;
}

.custom-checklist__input + label {
  display: inherit;
  position: relative;
  padding-left: 56px;
  cursor: pointer;
}

.custom-checklist__input + label::before {
  content: '';
  display: inline-block;
  width: 40px;
  height: 40px;
  position: absolute;
  left: 0;
  top: 50%;
  transform: translateY(-50%);
  background-color: rgba($color--basic-blue, .25);
  border-radius: 50%;
}

.custom-checklist__input:checked + label::before {
  background: url(/images/icons/check.svg) center/1.5em no-repeat,
  linear-gradient(270deg, $color--basic-green 0%, $color--basic-lime 100%);
  border-radius: 50%;
}

.custom-checklist-counter {
  font-size: 19px;
  line-height: 17px;
  color: $color--basic-green;
  margin-bottom: 49px;
}
</style>
